<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="Lbq" name="Lbq">
      <RankTabData :data="allData.Lbq"/>
    </el-tab-pane>
    <el-tab-pane label="Endless" name="Endless">
      <RankTabData :data="allData.Endless"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossGrand" name="RaidbossGrand">
      <RankTabData :data="allData.RbGrand"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossLittle" name="RaidbossLittle">
      <RankTabData :data="allData.RbLittle"/>
    </el-tab-pane>
    <el-tab-pane label="Versus" name="Versus">
      <RankTabData :data="allData.Versus"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import RankTabData from "./RankTabData.vue"

function noop() {}

export default {
  name: "event",
  components: {RankTabData},
  props: {
    allData : {},
  },
  data: () => {
    return {
      tabActive: "Lbq",
    }
  },
  methods: {
  }
};

</script>